import React, { Component, Fragment } from 'react';
import { Form, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import ReactTable from 'Common/ReactTableWrapper';
import { AssignEntitiesEnum, UserEnum } from 'Common/FieldEnum';
import {
  ReactTableWrapperColumnProperties,
  UNSAVED_MESSAGE,
} from 'Common/Constants';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { ASSIGN_ENTITIES_FORM_NAME } from 'Common/FormEnum';

import {
  getUsers,
  clearUserData,
  getSitesByUserName,
  getSiteGroupsByUserName,
} from '../../../state/assignEntities/actions';
import {
  AssignEntitiesUserGridEnum,
  ComponentMapping,
  getCheckedUserGridData,
  getComponentOnSelection,
  getFilteredIds,
  GridNames,
  GridResetInitialValueEnum,
} from '../../../helper/assignEntities';
import * as Selectors from '../../../state/assignEntities/selectors';

class UserGrid extends Component {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    allSitesData: PropTypes.array.isRequired,
    allUsersData: PropTypes.array.isRequired,
    sitesByUserName: PropTypes.array.isRequired,
    siteGroupsByUserName: PropTypes.array.isRequired,
    usersBySiteId: PropTypes.array.isRequired,
    userGridInfo: PropTypes.array,
    resetGridPage: PropTypes.object.isRequired,
    setIsReadOnlyState: PropTypes.func,
    onResetPageOnDataChange: PropTypes.func,
    onFilteredChange: PropTypes.func,
    getUsers: PropTypes.func.isRequired,
    clearUserData: PropTypes.func.isRequired,
    getSitesByUserName: PropTypes.func.isRequired,
    getSiteGroupsByUserName: PropTypes.func.isRequired,
    rightSideGridReactTableRef: PropTypes.object,
    isReadOnly: PropTypes.bool,
    loadingAllUsers: PropTypes.bool.isRequired,
    isRightGridFiltered: PropTypes.bool,
    isRightSideUserGrid: PropTypes.bool,
    isLeftSideUserGrid: PropTypes.bool,
    isRightSideSiteGroupGrid: PropTypes.bool,
    isRightSideSiteGrid: PropTypes.bool,
    sortOptionsValue: PropTypes.string.isRequired,
    dropDownValue: PropTypes.string.isRequired,
  };

  static defaultProps = {
    isReadOnly: true,
    isRightGridFiltered: false,
    isRightSideUserGrid: false,
    isLeftSideUserGrid: false,
    isRightSideSiteGroupGrid: false,
    isRightSideSiteGrid: false,
    rightSideGridReactTableRef: null,
    onFilteredChange: () => {},
    setIsReadOnlyState: () => {},
    onResetPageOnDataChange: () => {},
    userGridInfo: [],
  };

  state = {
    showUnsavedModal: false,
    rowInfo: null,
  };
  columns = [
    {
      Header: () => {
        const {
          dataSource,
          input: { value },
          rightSideGridReactTableRef,
          userGridInfo,
        } = this.props;
        let check = false;
        if (rightSideGridReactTableRef && rightSideGridReactTableRef.current) {
          const sortedData = rightSideGridReactTableRef.current.getResolvedState()
            .sortedData;
          check =
            sortedData.length > 0 &&
            sortedData.length ===
              getCheckedUserGridData(sortedData, userGridInfo).length;
        } else if (
          dataSource &&
          value &&
          value.length &&
          dataSource.length > 0
        ) {
          check = dataSource.length === value.length;
        }
        return (
          <Checkbox
            checked={check}
            onClick={(e, data) => {
              this.handleHeaderLevelCheckBox(data.checked);
            }}
          />
        );
      },
      Cell: ({ original }) => {
        const {
          input: { value },
        } = this.props;
        return (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              checked={
                value &&
                value.length > 0 &&
                value.includes(original[AssignEntitiesUserGridEnum.UserName])
              }
              onClick={(e, { checked }) => {
                this.handleChangeCheckbox(original, checked);
              }}
            />
          </div>
        );
      },
      accessor: UserEnum.CheckBox,
      ...ReactTableWrapperColumnProperties,
      sortable: false,
      filterable: false,
      maxWidth: 72,
    },
    {
      Header: 'User Name',
      accessor: UserEnum.UserName,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'First Name',
      visibilityName: 'First Name',
      accessor: UserEnum.FirstName,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Last Name',
      accessor: UserEnum.LastName,
      ...ReactTableWrapperColumnProperties,
    },
  ];

  handleHeaderLevelCheckBox = checked => {
    let users = [];
    const {
      isRightGridFiltered,
      rightSideGridReactTableRef,
      dataSource,
      userGridInfo,
    } = this.props;
    if (
      isRightGridFiltered &&
      rightSideGridReactTableRef &&
      rightSideGridReactTableRef.current
    ) {
      const sortedData = rightSideGridReactTableRef.current.getResolvedState()
        .sortedData;
      const sortedUserData = getFilteredIds(
        sortedData,
        AssignEntitiesUserGridEnum.UserName
      );
      let userGridInfoCopy = [...userGridInfo];
      let usersToChange;
      if (checked) {
        usersToChange = _.union(sortedUserData, userGridInfoCopy);
      } else {
        _.remove(userGridInfoCopy, userName => {
          return sortedUserData.includes(userName);
        });
        usersToChange = userGridInfoCopy;
      }
      this.props.input.onChange(usersToChange);
    } else {
      users = checked
        ? _.map(dataSource, user => {
            return user[AssignEntitiesUserGridEnum.UserName];
          })
        : [];
      this.props.input.onChange(users);
    }
    this.props.setIsReadOnlyState(false);
  };

  componentDidMount() {
    const {
      getUsers,
      isLeftSideUserGrid,
      isRightSideSiteGrid,
      getSitesByUserName,
      getSiteGroupsByUserName,
      isRightSideSiteGroupGrid,
    } = this.props;
    getUsers().then(() => {
      const { dataSource } = this.props;
      if (dataSource && dataSource.length) {
        isLeftSideUserGrid &&
          isRightSideSiteGrid &&
          getSitesByUserName(dataSource[0][UserEnum.UserName]).then(() => {
            this.props.input.onChange([dataSource[0].UserName]);
          });
        isLeftSideUserGrid &&
          isRightSideSiteGroupGrid &&
          getSiteGroupsByUserName(dataSource[0][UserEnum.UserName]).then(() => {
            this.props.input.onChange([dataSource[0].UserName]);
          });
      }
    });
    if (isLeftSideUserGrid) {
      this.props.onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.User]: false,
      });
      const columns = [...this.columns];
      columns.shift();
      this.columns = columns;
    }
  }
  handleChangeCheckbox = (original, checked) => {
    const formValues =
      this.props.input.value && this.props.input.value.length
        ? _.cloneDeep(this.props.input.value)
        : [];
    let index = formValues.indexOf(original[UserEnum.UserName]);
    if (checked) {
      index === -1 && formValues.push(original[UserEnum.UserName]);
    } else {
      if (index !== -1) {
        formValues.splice(index, 1);
      }
    }
    this.props.setIsReadOnlyState(false);
    this.props.input.onChange(formValues);
  };

  componentWillUnmount() {
    this.props.input.onChange([]);
  }

  onRowClickProp = (state, rowInfo) => {
    const { isRightSideUserGrid, isLeftSideUserGrid, input } = this.props;
    let styleObj = {};
    if (
      isLeftSideUserGrid &&
      rowInfo &&
      rowInfo.original &&
      input.value &&
      input.value.indexOf(rowInfo.original.UserName) !== -1
    ) {
      styleObj = {
        color: '#df5a17',
        fontWeight: '600',
      };
    }
    return {
      onClick: e => {
        const { direction, sortOptionsValue, dropDownValue } = this.props;
        const renderedComponent = getComponentOnSelection(
          sortOptionsValue,
          dropDownValue,
          direction
        );
        if (input && input.value && input.value.length) {
          if (
            isLeftSideUserGrid &&
            input.value.indexOf(rowInfo.original.UserName) === -1
          ) {
            const showUnsavedModal = !this.props.isReadOnly;
            this.setState(
              {
                showUnsavedModal: showUnsavedModal,
                rowInfo,
              },
              () => {
                if (!showUnsavedModal) {
                  this.getAssociatedGridDetails();
                  if (
                    renderedComponent ===
                      ComponentMapping.SiteToUsersComponents ||
                    renderedComponent ===
                      ComponentMapping.SiteGroupToUsersComponents
                  ) {
                    this.props.onResetPageOnDataChange({
                      ...GridResetInitialValueEnum,
                      [GridNames.Site]: false,
                      [GridNames.User]: true,
                    });
                  } else if (
                    renderedComponent ===
                      ComponentMapping.UserToSitesComponents ||
                    renderedComponent ===
                      ComponentMapping.UserToSiteGroupsComponents
                  ) {
                    this.props.onResetPageOnDataChange({
                      ...GridResetInitialValueEnum,
                      [GridNames.User]: false,
                      [GridNames.Site]: true,
                    });
                  }
                }
              }
            );
          } else if (isRightSideUserGrid) {
            if (
              renderedComponent === ComponentMapping.SiteToUsersComponents ||
              renderedComponent === ComponentMapping.UserToSitesComponents ||
              renderedComponent ===
                ComponentMapping.SiteGroupToUsersComponents ||
              renderedComponent === ComponentMapping.UserToSiteGroupsComponents
            ) {
              this.props.onResetPageOnDataChange({
                ...GridResetInitialValueEnum,
                [GridNames.Site]: false,
                [GridNames.User]: false,
              });
            }
          }
        }
      },
      style: styleObj,
    };
  };

  handleUnsavedModal(result) {
    const { direction, sortOptionsValue, dropDownValue } = this.props;
    const renderedComponent = getComponentOnSelection(
      sortOptionsValue,
      dropDownValue,
      direction
    );
    if (result) {
      this.props.setIsReadOnlyState(true);
      this.getAssociatedGridDetails();
      if (
        renderedComponent === ComponentMapping.SiteToUsersComponents ||
        renderedComponent === ComponentMapping.SiteGroupToUsersComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Site]: false,
          [GridNames.User]: true,
        });
      } else if (
        renderedComponent === ComponentMapping.UserToSitesComponents ||
        renderedComponent === ComponentMapping.UserToSiteGroupsComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.User]: false,
          [GridNames.Site]: true,
        });
      }
    } else {
      if (
        renderedComponent === ComponentMapping.SiteToUsersComponents ||
        renderedComponent === ComponentMapping.UserToSitesComponents ||
        renderedComponent === ComponentMapping.SiteGroupToUsersComponents ||
        renderedComponent === ComponentMapping.UserToSiteGroupsComponents
      ) {
        this.props.onResetPageOnDataChange({
          ...GridResetInitialValueEnum,
          [GridNames.Site]: false,
          [GridNames.User]: false,
        });
      }
    }
    this.setState({
      showUnsavedModal: false,
      rowInfo: null,
    });
  }

  getAssociatedGridDetails = () => {
    const {
      getSiteGroupsByUserName,
      isRightSideSiteGroupGrid,
      isLeftSideUserGrid,
      isRightSideSiteGrid,
      getSitesByUserName,
    } = this.props;
    const { rowInfo } = this.state;
    if (rowInfo && rowInfo.original) {
      if (isRightSideSiteGrid) {
        getSitesByUserName(rowInfo.original.UserName, isRightSideSiteGrid).then(
          () => {
            this.props.input.onChange([rowInfo.original.UserName]);
          }
        );
      } else if (isLeftSideUserGrid && isRightSideSiteGroupGrid) {
        getSiteGroupsByUserName(rowInfo.original.UserName).then(() => {
          this.props.input.onChange([rowInfo.original.UserName]);
        });
      }
    }
  };

  render() {
    const {
      loadingAllUsers,
      dataSource,
      resetGridPage,
      onResetPageOnDataChange,
      onFilteredChange,
      rightSideGridReactTableRef,
    } = this.props;

    return (
      <Fragment>
        <Form.Field>
          <ReactTable
            reactTableRef={rightSideGridReactTableRef}
            minRows={0}
            loading={loadingAllUsers}
            data={dataSource ? dataSource : []}
            resizable={true}
            className={'-striped -highlight grid--fixed-row-height'}
            loadingText={loadingAllUsers ? 'Loading...' : ''}
            defaultFilterMethod={caseInsensitiveFilter}
            noDataText={loadingAllUsers ? '' : 'No sites found'}
            getTrProps={this.onRowClickProp}
            columns={this.columns}
            menu={false}
            saveState={{
              tableName: TableNamesEnum.ASSIGN_ENTITIES_USER_GRID_TABLE,
            }}
            resetPageOnDataChange={resetGridPage[GridNames.User]}
            onResetPageOnDataChange={onResetPageOnDataChange}
            onFilteredChange={onFilteredChange}
          />
        </Form.Field>

        <YesNoDialog
          showDialog={this.state.showUnsavedModal}
          title="Un-saved changes detected"
          question={UNSAVED_MESSAGE}
          yesCallback={() => {
            this.handleUnsavedModal(true);
          }}
          noCallback={() => {
            this.handleUnsavedModal(false);
          }}
        />
      </Fragment>
    );
  }
}

const selector = formValueSelector(ASSIGN_ENTITIES_FORM_NAME);
const mapStateToProps = state => {
  return {
    loadingAllUsers: Selectors.getLoadingAllUsers(state),
    allUsersData: Selectors.getAllUsersData(state),
    sitesByUserName: Selectors.getSitesByUserName(state),
    siteGroupsByUserName: Selectors.getSiteGroupsByUserName(state),
    usersBySiteId: Selectors.getUsersBySiteId(state),

    userGridInfo: selector(state, AssignEntitiesEnum.UserGridInfo),
    sortOptionsValue: selector(state, AssignEntitiesEnum.SortOptions),
    dropDownValue: selector(state, AssignEntitiesEnum.To),
  };
};
const mapDispatchToProps = {
  getUsers,
  clearUserData,
  getSitesByUserName,
  getSiteGroupsByUserName,
};
export const UserGridContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserGrid);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/containers/assignEntities/UserGridContainer.js